import styled from "styled-components";
import bg from "../../../../../images/pure-entertainment-bg.png";

const PureEntertainmentContainer = styled.div`
  background: url(${bg}) left top no-repeat;
  background-size: cover;
  padding: 30px 20px 80px;
  margin-top: 100px;
  h2 {
    font-weight: 700 !important;
    color: #fff !important;
    font-size: 24px !important;
    text-align: center !important;
    margin-bottom: 40px;
  }
  p {
    color: #fff;
  }
  .content {
    text-align: center;
    width: 100%;
    max-width: 1000px;
    margin: 30px auto auto;
    line-height: 150%;
    color: #fff;
    white-space: pre-wrap;
    font-size: 18px;
    p {
      line-height: 150%;
    }
    button {
      background: ${(props) => props.theme.colors.primary.main};
      color: #fff;
      width: 135px;
      margin: 60px auto 0;
      display: block;
      &:hover {
        box-shadow: 0px 3px 1px -2px rgb(255 255 255 / 20%), 0px 2px 2px 0px rgb(255 255 255 / 14%),
          0px 1px 5px 0px rgb(255 255 255 / 12%);
        background: ${(props) => props.theme.colors.primary.main}
      }
    }
  }
`;

export default PureEntertainmentContainer;
